import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBellIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.84167 16.334C5.84167 17.2549 6.58333 18 7.5 18C8.41667 18 9.15833 17.2549 9.15833 16.334H5.84167ZM7.5 3.76744C9.8 3.76744 11.6667 5.64279 11.6667 7.95349V13.814H3.33333V7.95349C3.33333 5.64279 5.2 3.76744 7.5 3.76744ZM7.5 0C6.80833 0 6.25 0.56093 6.25 1.25581V2.23535C3.63333 2.80465 1.66667 5.14884 1.66667 7.95349V12.9767L0 14.6512V15.4884H15V14.6512L13.3333 12.9767V7.95349C13.3333 5.14884 11.3667 2.80465 8.75 2.23535V1.25581C8.75 0.56093 8.19167 0 7.5 0Z",
		fill: "currentColor"
	})
});
export default SvgBellIcon;
